import { render, staticRenderFns } from "./SelectTree.vue?vue&type=template&id=56cffc22&scoped=true"
import script from "./SelectTree.vue?vue&type=script&lang=js"
export * from "./SelectTree.vue?vue&type=script&lang=js"
import style0 from "./SelectTree.vue?vue&type=style&index=0&id=56cffc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cffc22",
  null
  
)

export default component.exports